<template>
  <div class="modernCounselorCard">
    <div class="modernCounselorCard__inner">
      <div v-if="isCounselor" class="u-width-10">
        <div  :class="{'counselorarea__content':detailMode}">
          <div class="counselor_wrap">
            <div class="imgarea">
              <div class="img">
                <img :alt="counselor.name" :src="counselor.image_url" />
              </div>
            </div>
            <div class="description">
              <p class="description__name u-mg-b-1">{{ counselor.name }}</p>
              <p class="description__profile">{{ counselor.profile }}</p>
            </div>
          </div>
          <div class="message u-mg-t-1" v-if="showComment && counselor.selling_point">
            <p class="message__title">メッセージ</p>
            <p class="message__text">{{ counselor.selling_point }}</p>
          </div>
        </div>
        <div class="divination" v-if="showDivination && this.divinationArr">
          <span class="divinationTag" v-for="(item, index) in this.divinationArr" :key="item">{{item}}</span>
        </div>
      </div>
      <app-loading class="u-mg-center" :is-loading="true" v-else></app-loading>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
// mutation types
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'modern-counselor-card',
  data() {
    return {
      isCounselor: false,
      divinationArr: []
    }
  },
  computed: {
    ...mapState({
      counselor: state => state.counselors.counselor
    })
  },
  props: {
    counselorId: [Number, String],
    showComment: { type: Boolean, default: false },
    showDivination: { type: Boolean, default: false },
    detailMode: { type: Boolean, default: false }
  },
  mounted() {
    this.$store.dispatch(type.RESET_COUNSELOR)
    if(this.counselorId){
      this.$store.dispatch(type.GET_COUNSELOR,this.counselorId).then(() => {
        this.isCounselor = true
        if(this.counselor.divination_name != null){ this.setDivinationArr() }
      })
    }
  },
  methods: {
    setDivinationArr() {
      let divinationList = this.counselor.divination_name.split(',')
      this.divinationArr = divinationList.filter((x, i, self) => self.indexOf(x) === i);

    }
  }
}</script>
<style lang="scss">
.modernCounselorCard {
  width: 100%;

  p {
    margin: 0;
  }

  &__inner {
    display: flex;
  }
  .counselor_wrap {
    display: inline-flex;
    .imgarea {
      display: flex;
      align-items: center;

      .img {
        height: 56px;

        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
        }
      }
    }
  }

  .description {
    margin-left: 12px;

    &__name {
      font-size: 14px;
      letter-spacing: 1px;
      line-height: 14px;
      color: #141414;
    }

    &__profile {
      line-height: 16px;
      font-size: 12px;
    }
  }

  .message {
    background: #FEF5F9;
    border: 1px solid #F2D0DF;
    border-radius: 8px;
    padding: 12px;
    position: relative;

    &:after {
      content: '';
      width: 14px;
      height: 12px;
      position: absolute;
      top: -9px;
      background: url('/static/img/common/balloon_triangle_pink.png');
      background-size: 100%;
      background-repeat: no-repeat;
    }

    &__title {
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;
      letter-spacing: 1px;
      color: #ed1e79;
      margin-bottom: 4px;
    }

    &__text {
      line-height: 16px;
      font-size: 12px;

    }
  }

  .divination {
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ModernCounselorCard.vue